import { environment } from '../../../environments/environment';
import { Utilities } from '../../shared/utilities'

export const TCCPConstantValues = Object.freeze({
    base: {
        url_contexts: {
            ADMIN: 'admin',
            TOYOTA_EXTERNAL: 'toyotaaudioandconnectedservicessupport',
            TOYOTA_INTERNAL: 'connectedtechnologiestoyota',
            LEXUS_EXTERNAL: 'lexusconnectedtechnologysupport',
            LEXUS_INTERNAL: 'connectedtechnologieslexus',
            TOYOTA_QUICKGUIDE: 'toyotaguide',
            LEXUS_QUICKGUIDE: 'lexusguide',
            ADMIN_TITLE: 'Telematics Admin Portal',
            TOYOTA_TITLE: 'Toyota Audio & Connected Services Support',
            LEXUS_TITLE: 'Lexus Connected Technology Support',
        }
    },
    admin: {
        modules: {
            FLOW_MODULE: 'Flow Modeule',
            CAPABILITY_MODULE: 'Capability Module',
            BANNER_MODULE: 'Banner Module'
        },
        methods: {
            getFlow: 'getFlow',
            getDoneFlow: 'getDoneFlow',
            getImages: 'getImages',
            getCapabilityList: 'getCapabilityList',
            saveCapabilityList: 'saveCapabilityList',
            getBanner: 'getBanner',
            saveBanner: 'saveBanner'
        },
        Urls: {
            IMAGE_COMMON_PATH: '../../../../assets/images/',
            IMAGE_PATH: environment.baseURL,
            S3_EDIT_IMAGE_PATH: `${environment.baseURL}content/common/edit.svg`,
            SVG_PATH: environment.baseURL,
            BASE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            MODEL_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model?source=',
            YEAR_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model-year',
            FEATURE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature',
            IMAGE_UPLOAD: environment.baseURL + Utilities.getEnvironment() + 'content/',
            VIDEO_UPLOAD: environment.baseURL + Utilities.getEnvironment() + 'content',
            DELETE_IMAGE: environment.baseURL + Utilities.getEnvironment() + 'content',
            GET_FLOWS_BY_ID: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow/get-all-flows-by-feature',
            GET_ALL_FEATURE: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/get-all',
            GET_SUBFEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            UPDATE_SUBFEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            LEXUSAPP: '2b0a13936f5b0ca31780fae92ff96a3e',
            BLUETOOTH: 'eee5f966cc58f909ee534403b9bbe446',
            DONE_URL: '../../../../assets/data/',
            GET_ALL_VEHICLE: environment.baseURL + Utilities.getEnvironment() + 'vehicle/get-all-vehicles?source=',
            GET_VEHICLE: environment.baseURL + Utilities.getEnvironment() + 'vehicle?source=',
            UPDATE_VEHICLE: environment.baseURL + Utilities.getEnvironment() + 'vehicle?source=',
            GET_ALL_TAGNAME: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow/get-all-tag-names',
            DELETE_FEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            CHECK_S3_FILE: environment.baseURL + Utilities.getEnvironment() + 'content/check-file',
            DELETE_VEHICLE: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model',
            GET_TAGS_BY_FEATURE: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow/get-tagnames-by-feature',
            UPDATE_DOCUMENT: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/document',
            SEND_MAIL_URL: environment.baseURL + Utilities.getEnvironment() + 'send-mail',
            UPDATE_FEATURE_STATUS: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/publish',
            DELETE_FEATURES: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow/features',
            GET_ACCESS_POLICY_URL: environment.baseURL + Utilities.getEnvironment() + 'user-access/policies',
            GET_ACCESS_ROLE_URL: environment.baseURL + Utilities.getEnvironment() + 'user-access/roles',
            COPY_FEATURE: environment.baseURL + Utilities.getEnvironment() + 'copy-feature',
            GET_ALL_VEHICLE_BY_FEATURE: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model/feature/vehicles',
            UPDATE_VEHICLES: environment.baseURL + Utilities.getEnvironment() + 'vehicles?source=',
            GET_ERROR_MESSAGES: environment.baseURL + Utilities.getEnvironment() + 'apps/platform/message',
            GET_VEHICLE_INFO: environment.baseURL + Utilities.getEnvironment() + 'vehicle-detail/',
            GET_FILTERED_FEATURE_INFO: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/support/topics',
            MESSAGE_GUIDE_EXCEL_UPLOAD_PATH: environment.baseURL + Utilities.getEnvironment() + 'apps/platform-message/upload',
            CAPABILITY_CONTEXT: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/capabilities/',
            BANNER_CONTEXT: environment.baseURL + Utilities.getEnvironment() + 'notification/banners/',
            GET_IMAGE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/images',
            CATEGORY_MAPPING: environment.baseURL + Utilities.getEnvironment() + 'feature/category'
        },
        FIXED_VALUES: {
            SUCCESS: 'SUCCESS',
            ERROR: 'ERROR',
            MESSAGE_TYPE_SUCCESS: 'success',
            MESSAGE_TYPE_DANGER: 'danger',
            SVG_EXTENSION: 'svg',
            MENU: 'menu',
            ADD: 'ADD',
            VIEW: 'VIEW',
            EDIT: 'EDIT',
            ADD_FEATURE: 'Add Support Topic',
            VIEW_FEATURE: 'View Support Topic',
            EDIT_FEATURE: 'Edit Support Topic',
            ADD_STEP: 'Add Step',
            VIEW_STEP: 'View Step',
            EDIT_STEP: 'Edit Step',
            DATE_FORMAT: 'MM/dd/yyyy',
            DATE_FORMAT_WITH_SECONDS: 'MM/dd/yyyy HH:mm:ss',
            MODEL: 'model',
            CLASSIFICATION: 'classification',
            YEAR: 'year',
            GENERATION: 'generation',
            GENERIC_CAPABILITY: 'generic'
        },
        messages: {
            STEP_ADD_SUCCESS_MESSAGE: 'The Step is added successfully',
            STEP_UPDATE_SUCCESS_MESSAGE: 'The Step is updated successfully',
            PNG_FORMAT_MESSAGE: 'Only PNG/JPG/GIF file format is allowed for Images',
            BADGE_PNG_FORMAT_MESSAGE: 'Only PNG file format is allowed for badges',
            SVG_PNG_FORMAT_MESSAGE: 'Only PNG/SVG/JPG file format is allowed for Tile logos',
            TILE_MANDATORY_MESSAGE: 'Tile text is missing',
            CONTROL_MANDATORY_MESSAGE: 'Button text is missing',
            TILE_EXISTS_MESSAGE: 'Tile with the same text already exists',
            CONTROL_EXISTS_MESSAGE: 'Button with the same text already exists',
            IMAGE_VIDEO_FORMAT_MESSAGE: 'Only PNG/JPG/SVG/GIF file format is allowed for Images and only MP4 file format is allowed for Videos',
            MP4_FORMAT_MESSAGE: 'Only MP4 file format is allowed for Videos',
            NOTES_ERROR_MESSAGE: 'TIP is required',
            PAGENAME_ERROR_MESSAGE: 'Page Name is required',
            PAGENAME_EXISTS_MESSAGE: 'Page Name already exists for another Step',
            DISPLAYNAME_ERROR_MESSAGE: 'Display Name is required',
            INFORMATION_ERROR_MESSAGE: 'Information is required',
            STEP_DELETE_CONFIRMATION_MESSAGE: 'Are you sure you want to delete the Step?',
            STEP_DELETE_CONFIRMATION_MESSAGE1: 'Deleting this step will delete controls and all the linked steps. Continue?',
            ICON_MANDATORY_MESSAGE: 'Icon is required',
            FILE_ALREADY_EXIST_ERROR: 'The filename already exists. Please select a different file.',
            MARK_CURRENT_STEP_AS_LAST_MESSAGE: 'Marking the current step as last step will delete the ' +
                +'rest of the steps in the flow. Do you want to proceed?',
            SPLIT_SCREEN_CONFIRMTION_MESSAGE: 'Checking Split Screen, disables Tile and Control options. Do you want to proceed with Yes/No',
            DISCLAIMER_MANDATORY_MESSAGE: 'Disclamier Title & Disclamier is required',
            EXCEL_FILE_FORMAT_ERROR: 'Incorrect file format. Only .xlsx file type is allowed',
            UPLOAD_EXCEL_FILE_ERROR: 'Error in uploading data',
            UPLOAD_SUCCESS_MESSAGE: 'Upload done successfully',
            DELETE_CVS_MAPPING_CONFIRMATION_MESSAGE: 'Are you sure you want to delete the mapping?',
            CVS_MAPPING_SAVE_SUCCESS_MESSAGE: 'CVS mapping successfully saved.',
            CVS_MAPPING_DELETE_SUCCESS_MESSAGE: 'CVS mapping successfully saved.',
            LOST_UNSAVED_MESSAGE: 'All unsaved data will be lost. Continue?',
            BANNER_SAVE_SUCCESS_MESSAGE: 'Banner successfully saved.',
            BANNER_DELETE_SUCCESS_MESSAGE: 'Banner successfully deleted.',
            BANNER_DELETE_CONFIRMATION_MESSAGE: 'Are you sure you want to delete the Banner?',
            SUPPORT_TOPIC_DELETE_MESSAGE: 'The Support Topic is deleted successfully',
            SUPPORT_TOPIC_DELETE_CONFIRMATION_MESSAGE: 'Are you sure you want to delete the Support Topic and the associated steps?',
            BANNER_PUBLISH_CONFIRMATION_MESSAGE: 'Only one Banner can be published at a time',
            CONTROL_AS_BUTTON_CONFIRMTION_MESSAGE: 'Are you sure you want to change all the controls to Buttons?',
            CONTROL_AS_TILE_CONFIRMTION_MESSAGE: 'Are you sure you want to change all the controls to Tiles?',
            SUPPORT_TOPIC_ORDER_SUCCESS_MESSAGE: 'The Support topic order is saved successfully'

        }
    },
    lexus: {
        modules: {
            FLOW_MODULE: 'Flow Modeule',
            BLUETOOTH_COMPATABILTITY_MODLE: 'Bluetooth Compatability Module',
            BANNER_MODULE: 'Banner Module'
        },
        methods: {
            getFlow: 'getFlow',
            getDoneFlow: 'getDoneFlow',
            getImages: 'getImages',
            getManufaturerList: 'getManufaturerList',
            getPhoneModels: 'getPhoneModels',
            getPhoneCompatabilityList: 'getPhoneCompatabilityList',
            getBanner: 'getBanner'
        },
        Urls: {
            DIVISION_IMAGE_UPLOAD: environment.baseURL + Utilities.getEnvironment() + 'upload-file/',
            IMAGE_COMMON_PATH: '../../../../assets/images/',
            IMAGE_PATH: environment.baseURL,
            SVG_PATH: environment.baseURL,
            BASE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            MODEL_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model?source=',
            YEAR_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model-year',
            FEATURE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature',
            LEXUSAPP: '2b0a13936f5b0ca31780fae92ff96a3e',
            BLUETOOTH: 'eee5f966cc58f909ee534403b9bbe446',
            DONE_URL: '../../../../assets/data/',
            GET_DOCUMENT_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/document',
            GET_DISCLAIMER_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/document/get-by-id',
            SEND_MAIL_URL: environment.baseURL + Utilities.getEnvironment() + 'send-mail',
            GET_SUBFEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            UPDATE_SUBFEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            GET_USER_INFO: environment.baseURL + Utilities.getEnvironment() + 'user-audit',
            UPDATE_USER_INFO: environment.baseURL + Utilities.getEnvironment() + 'user-audit',
            GET_ERROR_MESSAGES: environment.baseURL + Utilities.getEnvironment() + 'apps/platform/message',
            GET_ERROR_MESSAGES_PLATFORM: environment.baseURL + Utilities.getEnvironment() + 'apps/platform/message',
            GET_VEHICLE_INFO: environment.baseURL + Utilities.getEnvironment() + 'vehicle-detail/',
            GET_FILTERED_FEATURE_INFO: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/support/topics',
            BANNER_CONTEXT: environment.baseURL + Utilities.getEnvironment() + 'notification/banners/',
            GET_IMAGE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/images',
            CATEGORY_MAPPING: environment.baseURL + Utilities.getEnvironment() + 'feature/category',
            CTP_ADMIN_PORTAL: 'https://ctportal.telematicsct.com/dashboard',
            GET_ACCESS_ROLE_URL: environment.baseURL + Utilities.getEnvironment() + 'user-access/roles',
            GET_STEP_COUNT: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow/get-feature-by-detail',
            GET_SEARCH_SUGGESTIONS: environment.baseURL + Utilities.getEnvironment() + 'search-service/suggestions',
            GET_SEARCH_RESULTS: environment.baseURL + Utilities.getEnvironment() + 'search-service/search'
        },
        FIXED_VALUES: {
            SUCCESS: 'SUCCESS',
            ERROR: 'ERROR',
            MESSAGE_TYPE_SUCCESS: 'success',
            MESSAGE_TYPE_DANGER: 'danger',
            SVG_EXTENSION: 'svg',
            MENU: 'menu',
            INTERVAL: 48,
            GENERIC_CAPABILITY: 'generic',
            MANUFACTURER_DISCLAIMER: 'This list represents the phones that have been tested for compatibility with Vehicle Bluetooth and ' +
                ' Entune App Suite features to date. Test results are valid as of the date noted, using the specified versions of the ' +
                ' Audio Multimedia System, App Suite and Operating Systems. Phone performance depends on software, coverage and ' +
                'carrier. This list will be updated on an on-going basis as new phones are constantly being tested. If you do not ' +
                'find your phone on this list, please refer to  www.toyota.com/connect  for more details. Please note that Toyota does ' +
                'not make recommendations on phone carriers, manufactures, models or operating systems.'
        }
    },
    toyota: {
        modules: {
            FLOW_MODULE: 'Flow Modeule',
            BLUETOOTH_COMPATABILTITY_MODLE: 'Bluetooth Compatability Module',
            BANNER_MODULE: 'Banner Module'
        },
        methods: {
            getFlow: 'getFlow',
            getDoneFlow: 'getDoneFlow',
            getImages: 'getImages',
            getManufaturerList: 'getManufaturerList',
            getPhoneModels: 'getPhoneModels',
            getPhoneCompatabilityList: 'getPhoneCompatabilityList',
            getBanner: 'getBanner'
        },
        Urls: {
            DIVISION_IMAGE_UPLOAD: environment.baseURL + Utilities.getEnvironment() + 'upload-file/',
            IMAGE_COMMON_PATH: '../../../../assets/images/',
            IMAGE_PATH: environment.baseURL,
            SVG_PATH: environment.baseURL,
            BASE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            MODEL_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model?source=',
            YEAR_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model-year',
            FEATURE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature',
            TOYOTAAPP: 'eee5f966cc58f909ee534403b9bbe446',
            BLUETOOTH: 'eee5f966cc58f909ee534403b9bbe446',
            DONE_URL: '../../../../assets/data/',
            GET_DOCUMENT_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/document',
            GET_DISCLAIMER_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/document/get-by-id',
            SEND_MAIL_URL: environment.baseURL + Utilities.getEnvironment() + 'send-mail',
            GET_SUBFEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            UPDATE_SUBFEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            GET_USER_INFO: environment.baseURL + Utilities.getEnvironment() + 'user-audit',
            UPDATE_USER_INFO: environment.baseURL + Utilities.getEnvironment() + 'user-audit',
            GET_ERROR_MESSAGES: environment.baseURL + Utilities.getEnvironment() + 'apps/platform/message',
            GET_VEHICLE_INFO: environment.baseURL + Utilities.getEnvironment() + 'vehicle-detail/',
            GET_FILTERED_FEATURE_INFO: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/support/topics',
            BANNER_CONTEXT: environment.baseURL + Utilities.getEnvironment() + 'notification/banners/',
            GET_IMAGE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/images',
            CATEGORY_MAPPING: environment.baseURL + Utilities.getEnvironment() + 'feature/category',
            CTP_ADMIN_PORTAL: 'https://ctportal.telematicsct.com/dashboard',
            GET_ACCESS_ROLE_URL: environment.baseURL + Utilities.getEnvironment() + 'user-access/roles',
            GET_STEP_COUNT: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow/get-feature-by-detail',
            GET_SEARCH_SUGGESTIONS: environment.baseURL + Utilities.getEnvironment() + 'search-service/suggestions',
            GET_SEARCH_RESULTS: environment.baseURL + Utilities.getEnvironment() + 'search-service/search'
        },
        FIXED_VALUES: {
            SUCCESS: 'SUCCESS',
            ERROR: 'ERROR',
            MESSAGE_TYPE_SUCCESS: 'success',
            MESSAGE_TYPE_DANGER: 'danger',
            SVG_EXTENSION: 'svg',
            MENU: 'menu',
            INTERVAL: 48,
            GENERIC_CAPABILITY: 'generic',
            MANUFACTURER_DISCLAIMER: 'Information provided represents phones that have been tested for compatibility with Vehicle Bluetooth® and vehicle mobile app features to date.  Test results are accurate as of the date noted, using the specified Audio Multimedia System grades, cell phone Operating Systems and mobile apps associated with the respective vehicle.  Phone performance depends on software version, cellular reception and other factors not controlled by Toyota. Information will be updated on an on-going basis as new phones are constantly being tested.   If your cell phone or Operating System is not listed it may still be compatible however we do not have results to display at this time.  Please note that Toyota does not make recommendations on phone carriers, manufacturers, models or operating systems.',
            TOYOTA_MANUFACTURER_DISCLAIMER: 'This list represents the phones that have been tested for compatibility with Vehicle Bluetooth and' +
                ' Enform App Suite features to date. Test results are valid as of the date noted, using the specified versions of the' +
                'Lexus Multimedia System, App Suite and Operating Systems. Phone performance depends on software, coverage and' +
                'carrier. This list will be updated on an on-going basis as new phones are constantly being tested. If you do not' +
                'find your phone on this list, please refer to drivers.lexus.com for more details. Please note that Lexus does' +
                'not make recommendations on phone carriers, manufactures, models or operating systems.'
        }
    },
    toyotaguide: {
        modules: {
            FLOW_MODULE: 'Flow Modeule',
            BLUETOOTH_COMPATABILTITY_MODLE: 'Bluetooth Compatability Module',
            BANNER_MODULE: 'Banner Module'
        },
        methods: {
            getFlow: 'getFlow',
            getDoneFlow: 'getDoneFlow',
            getImages: 'getImages',
            getManufaturerList: 'getManufaturerList',
            getPhoneModels: 'getPhoneModels',
            getPhoneCompatabilityList: 'getPhoneCompatabilityList',
            getBanner: 'getBanner'
        },
        Urls: {
            DIVISION_IMAGE_UPLOAD: environment.baseURL + Utilities.getEnvironment() + 'upload-file/',
            IMAGE_COMMON_PATH: '../../../../assets/images/',
            IMAGE_PATH: environment.baseURL,
            SVG_PATH: environment.baseURL,
            BASE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            MODEL_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model?source=',
            YEAR_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model-year',
            FEATURE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature',
            TOYOTAAPP: 'eee5f966cc58f909ee534403b9bbe446',
            BLUETOOTH: 'eee5f966cc58f909ee534403b9bbe446',
            DONE_URL: '../../../../assets/data/',
            GET_DOCUMENT_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/document',
            GET_DISCLAIMER_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/document/get-by-id',
            SEND_MAIL_URL: environment.baseURL + Utilities.getEnvironment() + 'send-mail',
            GET_SUBFEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            UPDATE_SUBFEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            GET_USER_INFO: environment.baseURL + Utilities.getEnvironment() + 'user-audit',
            UPDATE_USER_INFO: environment.baseURL + Utilities.getEnvironment() + 'user-audit',
            GET_ERROR_MESSAGES: environment.baseURL + Utilities.getEnvironment() + 'apps/platform/message',
            GET_VEHICLE_INFO: environment.baseURL + Utilities.getEnvironment() + 'vehicle-detail/',
            GET_FILTERED_FEATURE_INFO: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/support/topics',
            BANNER_CONTEXT: environment.baseURL + Utilities.getEnvironment() + 'notification/banners/',
            GET_IMAGE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/images',
            CATEGORY_MAPPING: environment.baseURL + Utilities.getEnvironment() + 'feature/category',
            CTP_ADMIN_PORTAL: 'https://ctportal.telematicsct.com/dashboard',
            GET_ACCESS_ROLE_URL: environment.baseURL + Utilities.getEnvironment() + 'user-access/roles',
            GET_STEP_COUNT: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow/get-feature-by-detail',
            GET_SEARCH_SUGGESTIONS: environment.baseURL + Utilities.getEnvironment() + 'search-service/suggestions',
            GET_SEARCH_RESULTS: environment.baseURL + Utilities.getEnvironment() + 'search-service/search'
        },
        FIXED_VALUES: {
            SUCCESS: 'SUCCESS',
            ERROR: 'ERROR',
            MESSAGE_TYPE_SUCCESS: 'success',
            MESSAGE_TYPE_DANGER: 'danger',
            SVG_EXTENSION: 'svg',
            MENU: 'menu',
            INTERVAL: 48,
            GENERIC_CAPABILITY: 'generic'
        }
    },
    lexusguide: {
        modules: {
            FLOW_MODULE: 'Flow Modeule',
            BLUETOOTH_COMPATABILTITY_MODLE: 'Bluetooth Compatability Module',
            BANNER_MODULE: 'Banner Module'
        },
        methods: {
            getFlow: 'getFlow',
            getDoneFlow: 'getDoneFlow',
            getImages: 'getImages',
            getManufaturerList: 'getManufaturerList',
            getPhoneModels: 'getPhoneModels',
            getPhoneCompatabilityList: 'getPhoneCompatabilityList',
            getBanner: 'getBanner'
        },
        Urls: {
            DIVISION_IMAGE_UPLOAD: environment.baseURL + Utilities.getEnvironment() + 'upload-file/',
            IMAGE_COMMON_PATH: '../../../../assets/images/',
            IMAGE_PATH: environment.baseURL,
            SVG_PATH: environment.baseURL,
            BASE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            MODEL_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model?source=',
            YEAR_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model-year',
            FEATURE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature',
            TOYOTAAPP: 'eee5f966cc58f909ee534403b9bbe446',
            BLUETOOTH: 'eee5f966cc58f909ee534403b9bbe446',
            DONE_URL: '../../../../assets/data/',
            GET_DOCUMENT_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/document',
            GET_DISCLAIMER_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/document/get-by-id',
            SEND_MAIL_URL: environment.baseURL + Utilities.getEnvironment() + 'send-mail',
            GET_SUBFEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            UPDATE_SUBFEATURE_FLOW: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            GET_USER_INFO: environment.baseURL + Utilities.getEnvironment() + 'user-audit',
            UPDATE_USER_INFO: environment.baseURL + Utilities.getEnvironment() + 'user-audit',
            GET_ERROR_MESSAGES: environment.baseURL + Utilities.getEnvironment() + 'apps/platform/message',
            GET_VEHICLE_INFO: environment.baseURL + Utilities.getEnvironment() + 'vehicle-detail/',
            GET_FILTERED_FEATURE_INFO: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/support/topics',
            BANNER_CONTEXT: environment.baseURL + Utilities.getEnvironment() + 'notification/banners/',
            GET_IMAGE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature/images',
            CATEGORY_MAPPING: environment.baseURL + Utilities.getEnvironment() + 'feature/category',
            CTP_ADMIN_PORTAL: 'https://ctportal.telematicsct.com/dashboard',
            GET_ACCESS_ROLE_URL: environment.baseURL + Utilities.getEnvironment() + 'user-access/roles',
            GET_STEP_COUNT: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow/get-feature-by-detail',
            GET_SEARCH_SUGGESTIONS: environment.baseURL + Utilities.getEnvironment() + 'search-service/suggestions',
            GET_SEARCH_RESULTS: environment.baseURL + Utilities.getEnvironment() + 'search-service/search'
        },
        FIXED_VALUES: {
            SUCCESS: 'SUCCESS',
            ERROR: 'ERROR',
            MESSAGE_TYPE_SUCCESS: 'success',
            MESSAGE_TYPE_DANGER: 'danger',
            SVG_EXTENSION: 'svg',
            MENU: 'menu',
            INTERVAL: 48,
            GENERIC_CAPABILITY: 'generic'
        }
    },
    bluetooth: {
        modules: {
            FLOW_MODULE: 'Flow Modeule',
            BLUETOOTH_COMPATABILTITY_MODLE: 'Bluetooth Compatability Module'
        },
        methods: {
            getFlow: 'getFlow',
            getDoneFlow: 'getDoneFlow',
            getImages: 'getImages',
            getManufaturerList: 'getManufaturerList',
            getPhoneModels: 'getPhoneModels',
            getPhoneCompatabilityList: 'getPhoneCompatabilityList'
        },
        Urls: {
            BASE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature-flow',
            MODEL_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model?source=',
            YEAR_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-model-year',
            FEATURE_URL: environment.baseURL + Utilities.getEnvironment() + 'vehicle-feature',
            MANUFACTURER_URL: 'https://tcrp-stage.connectedtechnologies-telematicssupport.com/api/v2/'
        },
        FIXED_VALUES: {
            SUCCESS: 'SUCCESS',
            ERROR: 'ERROR',
            MESSAGE_TYPE_SUCCESS: 'success',
            MESSAGE_TYPE_DANGER: 'danger',
            SVG_EXTENSION: 'svg',
            MENU: 'menu'
        }
    },
    feedback: {
        messages: {
            FEEDBACK_SUCCESS_MESSAGE: 'Thanks for sharing your feedback!',
        }
    }

});

